import { createAction } from 'redux-actions'
import { urlBeneficiariosEndosos, urlBeneficiariosEndososCoberturas, urlCatalogoEntidadesFinancieras, urlEndososBeneficiarios, urlEndososCoberturas, urlEndososGeneralBeneficiarios, urlGuardarBeneficiariosCoberturasEndosos, urlGuardarBeneficiariosEndosos } from '../../constants/urls';


export const LISTA_ENDOSOS_HAS_ERRORED = "LISTA_ENDOSOS_HAS_ERRORED";
export const SET_DATA_LISTA_ENDOSOS = "SET_DATA_LISTA_ENDOSOS";
export const SET_DATA_LISTA_RAMOS = "SET_DATA_LISTA_RAMOS";
export const LISTA_ENDOSOS_LOADING = "LISTA_ENDOSOS_LOADING";
export const LIMPIAR_DATOS_LISTA_ENDOSOS = "LIMPIAR_DATOS_LISTA_ENDOSOS";

export const listaEndososHasErrored = createAction(LISTA_ENDOSOS_HAS_ERRORED);
export const listaEndososIsLoading = createAction(LISTA_ENDOSOS_LOADING);
export const setListaEndosos = createAction(SET_DATA_LISTA_ENDOSOS);
export const limpiarListaEndosos = createAction(LIMPIAR_DATOS_LISTA_ENDOSOS);

export const LISTA_BENEFICIARIOS_HAS_ERRORED = "LISTA_BENEFICIARIOS_HAS_ERRORED";
export const SET_DATA_LISTA_BENEFICIARIOS = "SET_DATA_LISTA_BENEFICIARIOS";
export const LISTA_BENEFICIARIOS_LOADING = "LISTA_BENEFICIARIOS_LOADING";
export const LIMPIAR_DATOS_LISTA_BENEFICIARIOS = "LIMPIAR_DATOS_LISTA_BENEFICIARIOS";

export const listaBeneficiariosHasErrored = createAction(LISTA_BENEFICIARIOS_HAS_ERRORED);
export const listaBeneficiariosIsLoading = createAction(LISTA_BENEFICIARIOS_LOADING);
export const setListaBeneficiarios = createAction(SET_DATA_LISTA_BENEFICIARIOS);
export const limpiarListaBeneficiarios = createAction(LIMPIAR_DATOS_LISTA_BENEFICIARIOS);

export const LISTA_GENERAL_ENDOSOS_HAS_ERRORED = "LISTA_GENERAL_ENDOSOS_HAS_ERRORED";
export const SET_DATA_LISTA_GENERAL_ENDOSOS = "SET_DATA_LISTA_GENERAL_ENDOSOS";
export const LISTA_GENERAL_ENDOSOS_LOADING = "LISTA_GENERAL_ENDOSOS_LOADING";
export const LIMPIAR_DATOS_LISTA_GENERAL_ENDOSOS = "LIMPIAR_DATOS_LISTA_GENERAL_ENDOSOS";

export const listaGeneralEndososHasErrored = createAction(LISTA_GENERAL_ENDOSOS_HAS_ERRORED);
export const listaGeneralEndososIsLoading = createAction(LISTA_GENERAL_ENDOSOS_LOADING);
export const setListaGeneralEndosos = createAction(SET_DATA_LISTA_GENERAL_ENDOSOS);
export const limpiarListaGeneralEndosos = createAction(LIMPIAR_DATOS_LISTA_GENERAL_ENDOSOS);


export const FetchListadoEndosos = (body) => async (dispatch) => {
  var url = urlEndososBeneficiarios;
  dispatch(listaEndososIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaEndosos());
        dispatch(setListaEndosos(data.data));
      } else {
        dispatch(setListaEndosos([]));
        dispatch(listaEndososHasErrored());
      }
    })
    .catch((response) => {
      dispatch(setListaEndosos([]));
      dispatch(listaEndososHasErrored());
    });
};

export const FetchListadoGeneralEndosos = (body) => async (dispatch) => {
  var url = urlEndososGeneralBeneficiarios;
  dispatch(listaGeneralEndososIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaGeneralEndosos());
        dispatch(setListaGeneralEndosos(data.data));
      } else {
        dispatch(setListaGeneralEndosos([]));
        dispatch(listaGeneralEndososHasErrored());
      }
    })
    .catch((response) => {
      dispatch(setListaEndosos([]));
      dispatch(listaGeneralEndososHasErrored());
    });
};


export const FetchListadoCoberturas = (body) => async (dispatch) => {
  var url = urlEndososCoberturas;
  dispatch(listaEndososIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaEndosos());
        dispatch(setListaEndosos(data.data));
      } else {
        dispatch(setListaEndosos([]));
        dispatch(listaEndososHasErrored());
      }
    })
    .catch((response) => {
      dispatch(setListaEndosos([]));
      dispatch(listaEndososHasErrored());
    });
};

export const FetchListadoEntidadesFinancieras = (body) => async (dispatch) => {
  var url = urlCatalogoEntidadesFinancieras;
  return await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        return data.data;
      } else {
        return [];
      }
    })
    .catch((response) => {

    });
};

export const FetchListadoBeneficiarios = (body) => async (dispatch) => {
  var url = urlBeneficiariosEndosos;
  dispatch(listaBeneficiariosIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaBeneficiarios());
        dispatch(setListaBeneficiarios(data));
      } else {
        dispatch(listaBeneficiariosHasErrored());
        dispatch(setListaBeneficiarios([]));
      }
    })
    .catch((response) => {
      dispatch(setListaBeneficiarios([]));
      dispatch(listaBeneficiariosHasErrored());
    });
}

export const FetchGuardarBeneficiariosEndosos = (body) => async (dispatch) => {
  const url = urlGuardarBeneficiariosEndosos;
  dispatch(listaBeneficiariosIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaBeneficiarios());
      } else {
        dispatch(listaBeneficiariosHasErrored());
      }
    })
    .catch((response) => {
      dispatch(listaBeneficiariosHasErrored());
    });
}

export const FetchGuardarBeneficiariosCoberturasEndosos = (body) => async (dispatch) => {
  const url = urlGuardarBeneficiariosCoberturasEndosos;
  dispatch(listaBeneficiariosIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaBeneficiarios());
      } else {
        dispatch(listaBeneficiariosHasErrored());
      }
    })
    .catch((response) => {
      dispatch(listaBeneficiariosHasErrored());
    });
}

export const FetchListadoBeneficiariosCoberturas = (body) => async (dispatch) => {
  var url = urlBeneficiariosEndososCoberturas;
  dispatch(listaBeneficiariosIsLoading());
  await fetch(url, {
    method: 'POST',
    body: JSON.stringify({
      ...body
    })
  })
    .then((response) => response.json())
    .then((data) => {
      if (data.transaccion) {
        dispatch(limpiarListaBeneficiarios());
        dispatch(setListaBeneficiarios(data));
      } else {
        dispatch(listaBeneficiariosHasErrored());
        dispatch(setListaBeneficiarios([]));
      }
    })
    .catch((response) => {
      dispatch(setListaBeneficiarios([]));
      dispatch(listaBeneficiariosHasErrored());
    });
}